import React from "react";
import "./TwoColumnSelectList.scss";

const TwoColumnSelectList = ({
  input,
  options,
  meta: { touched, error },
  multiSelect = true,
  selectedBackgroundColor = "#fff3cd",
  fontColor = "#111",
}) => {
  const currentValues = multiSelect
    ? Array.isArray(input.value)
      ? input.value
      : []
    : input.value;

  const isSelected = (item) => {
    if (multiSelect) {
      return currentValues.some((x) => x.value === item.value);
    } else {
      return currentValues?.value === item.value;
    }
  };

  const toggleValue = (item) => {
    if (multiSelect) {
      if (isSelected(item)) {
        input.onChange(currentValues.filter((x) => x.value !== item.value));
      } else {
        input.onChange([...currentValues, item]);
      }
    } else {
      input.onChange(item);
    }
  };

  return (
    <div className="TwoColumnSelectList">
      <div className="error-container">
        {touched && error && <p className="ErrorMessage">{error}</p>}
      </div>

      <div className="Grid">
        {options?.map((item) => {
          const selected = isSelected(item);
          return (
            <div
              key={item.value}
              className="Item"
              onClick={() => toggleValue(item)}
              style={{
                background: selected ? selectedBackgroundColor : "#fafafa",
                color: selected ? fontColor : "#050505",
              }}
            >
              <span>{item.label}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TwoColumnSelectList;
